import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../../../../modules/src/lib/core/services/menu.service';
import { CreateCorporateClientFormFactory } from './create-corporate-client-form.factory';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  CreateCorporateClientOptions,
} from '../../../../../../../../common/src/options/create-corporate-client.options';
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';

@Component({
  selector: 'app-create-corporate',
  templateUrl: './create-corporate.component.html',
  styleUrls: ['./create-corporate.component.scss'],
  standalone: false,
})
export class CreateCorporateComponent implements OnInit {

  public readonly form: AdvancedForm<CreateCorporateClientOptions> = this.corporateClientFormFactory.create();

  constructor(public readonly corporateClientFormFactory: CreateCorporateClientFormFactory, public menuService: MenuService) {
  }

  getCompanyName(): AdvancedFormControl<string, string, string> {
    return this.form.get('companyName') as AdvancedFormControl<string, string, string>;
  }

  ngOnInit(): void {
    this.form.buttonClick$.subscribe(() => {
      this.form.lifecycleStatus = FormLifecycleStatusEnum.Sending;

      setTimeout(() => {
        this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
      }, 800);
    });
  }

  getTitle() {
    const model = this.getCompanyName().value;

    if (model == '') {
      return 'Nouveau client particulier';
    }

    return model;
  }
}
